import { Route } from '@angular/router';
import { clientPortalRoutes } from '@hypenation/client-portal';

export const appRoutes: Route[] = [
  ...clientPortalRoutes,
  { path: '**', redirectTo: '' }
];
